import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import * as _ from "lodash";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const TPMEventSpendSearch: ISearch = {
    searchName: "Find TPM Event Spend",
    renderOptions: { ui5ResourceId: "TPMEventSpendSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: []
}

const vUI_TPM_Event_Spend_Search_Fields: {[id:string]: ISearchProviderField } = {

    WB_TEVTS_ID:         {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    EVENT_SPEND_ID:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Spend Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    EVENT_SPEND_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Spend Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SPEND_TYPE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Spend Type Id', columnResourceName: 'colSpendTypeId', alignment: HorizAlignment.Left}, domainOptions: { search: TPMEventSpendSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    SPEND_TYPE_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Spend Type', columnResourceName: 'colSpendTypeName', alignment: HorizAlignment.Left}, domainOptions: { search: TPMEventSpendSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    EVENT_SPEND_CURRENT_STATUS_NAME: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Spend Status', columnResourceName: 'colSpendTypeName', alignment: HorizAlignment.Left}, domainOptions: { search: TPMEventSpendSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    EVENT_SPEND_CURRENT_STATUS_TYPE: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Spend Status', columnResourceName: 'colSpendTypeName', alignment: HorizAlignment.Left}, domainOptions: { search: TPMEventSpendSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    WB_TEVT_ID:          {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    EVENT_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    EVENT_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    TYPE_NAME:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Type', columnResourceName: 'colTypeName', alignment: HorizAlignment.Left}, domainOptions: { search: TPMEventSpendSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    PLAN_NAME:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Plan', columnResourceName: 'colTypeName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    WB_CUST_ID_PLANNING: {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Cust Id Planning', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    PLANNINGCUSTOMER:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Planning Customer', columnResourceName: 'colPlanningCustomer', alignment: HorizAlignment.Left}, domainOptions: { search: TPMEventSpendSearch, profileId:"default", bUseSearchProvidersDistinctValues: true,maxLength: 256}},
    SUBPLANNINGCUSTOMER: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Sub Planning Customer', columnResourceName: 'colSubPlanningCustomer', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    INSTORE_START_DT:    {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'In Store Start Date', columnResourceName: 'colInStoreStart', alignment: HorizAlignment.Center}, domainOptions: {}},
    INSTORE_END_DT:      {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'In Store End Date', columnResourceName: 'colInStoreEnd', alignment: HorizAlignment.Center}, domainOptions: {}},
    SHIPMENT_START_DT:   {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Shipment Start Date', columnResourceName: 'colShipmentStart', alignment: HorizAlignment.Center}, domainOptions: {}},
    SHIPMENT_END_DT:     {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Shipment End Date', columnResourceName: 'colShipmentEnd', alignment: HorizAlignment.Center}, domainOptions: {}},
    CURRENT_STATUS_NAME: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Status', columnResourceName: 'colStatus', alignment: HorizAlignment.Left}, domainOptions: {search: TPMEventSpendSearch, profileId: "default", bUseSearchProvidersDistinctValues: true,  maxLength: 256}},
    NEXT_STATUS_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Next Status', columnResourceName: 'colNextStatus', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    NEXT_APPROVER:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Next Approver', columnResourceName: 'colNextApprover', alignment: HorizAlignment.Left}, domainOptions: {search: TPMEventSpendSearch, profileId: "default", bUseSearchProvidersDistinctValues: true,  maxLength: 256}},
    CREATED_BY:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Created By', columnResourceName: 'colCreatedBy', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    WB_PLNMGMT_ID:        {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Plan Mgmt ID',            columnResourceName: 'colPlanMgmtID',   alignment: HorizAlignment.Left}, domainOptions: { }},
    PLAN_MANAGEMENT_NAME: {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Plan Management',         columnResourceName: 'colPlanMagementName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    PLANNING_LEVEL_ID:    {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Planning Level ID',       columnResourceName: 'colLevelID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PLANNING_LEVEL_NAME:  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Planning Level',          columnResourceName: 'colLevelName', alignment: HorizAlignment.Left}, domainOptions: { search: TPMEventSpendSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    PLAN_PERIOD_NAME:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Plan Period',             columnResourceName: 'colPlanPeriodName', alignment: HorizAlignment.Left}, domainOptions: {search: TPMEventSpendSearch, profileId: "default", bUseSearchProvidersDistinctValues: true,  maxLength: 256}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}


const EventSpendSearchProviderBasic: ISearchProvider = {

    keyFields: {id:        'WB_TEVTS_ID',
                id_ui:     'EVENT_SPEND_ID',
                name:      'EVENT_SPEND_NAME',
                source_id: 'SOURCE_ID'
    },

    searchProviderFields: vUI_TPM_Event_Spend_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_TPM_Event_Spend_Search',
                this.searchProviderFields,
                [])

            SearchUtils.addPlanManagementFilter(findRequest, 'WB_PLNMGMT_ID')
                .then((ignore => {
                    return PASearch.findByRequest(findRequest)
                }))
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    },

    // Filter with drop down in the TPM Event Search
    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_TPM_Event_Spend_Search',
                this.searchProviderFields,
                [fieldName])

            SearchUtils.addPlanManagementFilter(findRequest, 'WB_PLNMGMT_ID')
                .then((ignore) => {
                    return PASearch.findByRequest(findRequest)
                })
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


// Tactic Refresh


const TPMEventSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "EventSpendSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Event Spend Id',     searchProviderFieldId: 'EVENT_SPEND_ID',      renderOptions: { }},
        {profileFilterName: 'Spend Type',         searchProviderFieldId: 'SPEND_TYPE_NAME',   bMultiSelect: true, renderOptions: { }},
        {profileFilterName: 'Spend Status',       searchProviderFieldId: 'EVENT_SPEND_CURRENT_STATUS_NAME',   bMultiSelect: true, renderOptions: { }},
        {profileFilterName: 'Event Id',           searchProviderFieldId: 'EVENT_ID',            renderOptions: { }},
        {profileFilterName: 'Name',               searchProviderFieldId: 'EVENT_NAME',          renderOptions: { }},
        {profileFilterName: 'Type',               searchProviderFieldId: 'TYPE_NAME',           bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Planning Level',     searchProviderFieldId: 'PLANNING_LEVEL_NAME', bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Period',             searchProviderFieldId: 'PLAN_PERIOD_NAME',    bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Status',             searchProviderFieldId: 'CURRENT_STATUS_NAME', bMultiSelect: true, renderOptions: { }},
        {profileFilterName: 'Approver',           searchProviderFieldId: 'NEXT_APPROVER',       bMultiSelect: true, renderOptions: { }},
        {profileFilterName: 'Created By',         searchProviderFieldId: 'CREATED_BY',          renderOptions: { }},
        {profileFilterName: 'Planning Customer',  searchProviderFieldId: 'PLANNINGCUSTOMER',    bMultiSelect: true, renderOptions: { }}

    ],  // ISearchFields
    profileDisplayFields: [
        'EVENT_SPEND_ID', 'SPEND_TYPE_NAME', 'EVENT_SPEND_CURRENT_STATUS_NAME',
        'EVENT_ID','EVENT_NAME','PLANNINGCUSTOMER','TYPE_NAME','CURRENT_STATUS_NAME',
        {columnTitle: "InStore Dates",   fields: ['INSTORE_START_DT','INSTORE_END_DT'], seperator: " - ",alignment: HorizAlignment.Center },
        {columnTitle: "Shipment Dates",   fields: ['SHIPMENT_START_DT','SHIPMENT_END_DT'], seperator: " - ",alignment: HorizAlignment.Center },
        'CREATED_BY','NEXT_APPROVER','PLANNING_LEVEL_NAME',{columnTitle: "Lock", lockClass: "TPMEvent", lockIdFieldName: "WB_TEVT_ID", bDisplayLockIcon: true, bDisplayLockOwner:true},
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: EventSpendSearchProviderBasic,

    profileTreeIdDefault: "byPlanType",
    profileTrees: [
        {treeId: "byPlan",
            treeName: "By Plan",
            nodeProviders: [new ColumnNodeProvider(['PLANNINGCUSTOMER','PLAN_NAME'], {defaultValues: "Empty Plan Name", levelDelimiter: "\\", ruggedTree: true})],
            renderOptions: {ui5: {leafIcon: "sap-icon://gantt-bars"}}},
        {treeId: "byPlanType",
            treeName: "By Plan, Type",
            nodeProviders: [new ColumnNodeProvider(['PLANNINGCUSTOMER','PLAN_NAME', 'TYPE_NAME'], {defaultValues: "Empty Plan Name", levelDelimiter: "\\", ruggedTree: true})],
            renderOptions: {ui5: {leafIcon: "sap-icon://gantt-bars"}}}
    ],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

TPMEventSpendSearch.searchProfiles = [TPMEventSearchProfileByName]
export {TPMEventSpendSearch}